import {FC} from 'react'
import {Link} from 'react-router-dom'

const Error500: FC = () => {
  return (
    <div className='w-100'>
      <div className='wc-auth__error-code'>500</div>
      <h1 className='wc-auth__heading'>System error</h1>
      <p className='wc-auth__subtitle'>
        Something went wrong — please try again in a moment.
      </p>
      <Link to='/' className='wc-auth__submit'>
        Go to homepage
      </Link>
    </div>
  )
}

export {Error500}
